
import React, { useEffect, useState } from "react";
import { Box, Checkbox, Grid, Paper, Typography } from "@mui/material";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { styled } from '@mui/material/styles';
import styles from '.././../../styles.module.css';
import { Icon } from '@iconify/react';
import { StyledTableCell, StyledTableCellPrint, StyledTableRow, } from '../../reusableComponent/StyledTable'
import convertToIndianWords from "../../reusableComponent/convertToIndianWords";


const AccountStatementPrint = ({ reportPrint, acStatement, CNS_Name, fromDate, toDate }) => {

    const login_details = sessionStorage.getItem('loginUser');
    const userD = JSON.parse(login_details);
    const userInfo = userD.userInfo;

    const dateConversion = (date) => {
        var today = new Date(date);
        var dd = String(today.getDate()).padStart(2, "0");
        var mm = String(today.getMonth() + 1).padStart(2, "0");
        var yyyy = today.getFullYear();
        const convDate = dd + "/" + mm + "/" + yyyy;
        return convDate;
    };


    return (
        <>
            <style type="text/css" media="print">
                {`
                @page {
                    size: Landscape;
                }

                @media print {
                    .page-break {
                        page-break-after: always;
                    }

                    .page-break:empty {
                        display: none;
                    }
                }
            `}
            </style>
            <Box style={{ margin: '30px' }} className="print-source">
                <Paper sx={{ margin: '55px 15px 30px 15px', boxShadow: 'none', border: '1px solid #000000', height: '90vh' }}   >
                    <Grid container sx={{}}>
                        <Grid item xs={12} sx={{ backgroundColor: '#c0c0c0' }}>
                            <Typography sx={{ textAlign: 'center', fontSize: '18px', fontWeight: 'bold', padding: '1px' }}>
                                {(acStatement).toUpperCase()} ACCOUNT STATEMENT
                            </Typography>
                        </Grid>
                        <Grid item xs={12} >
                            <Typography className={`${styles.erp_lable}`}><span style={{fontWeight: 'bold'}}>Party Name: </span> {CNS_Name} </Typography>
                            <Typography className={`${styles.erp_lable}`}><span style={{fontWeight: 'bold'}}> Date: </span> {fromDate} - {toDate}</Typography>
                        </Grid>
                    </Grid>
                    <TableContainer component={Paper} style={{ overflowY: 'auto', marginTop: '10px' }}>
                        <Table sx={{ minWidth: 650 }} size="small" stickyHeader >
                            <TableHead>
                                <StyledTableRow>
                                    <StyledTableCell align="left" className={`${styles.table_head}`} >Ref No </StyledTableCell>
                                    <StyledTableCell align="left" className={`${styles.table_head}`} >Date </StyledTableCell>
                                    <StyledTableCell align="left" className={`${styles.table_head}`} >Paymet Mode </StyledTableCell>
                                    <StyledTableCell align="left" className={`${styles.table_head}`} >Bank Name </StyledTableCell>
                                    <StyledTableCell align="right" className={`${styles.table_head}`} >Opening Balance </StyledTableCell>
                                    <StyledTableCell align="right" className={`${styles.table_head}`} >Credit Amount</StyledTableCell>
                                    <StyledTableCell align="right" className={`${styles.table_head}`} > Debit Amount </StyledTableCell>
                                    <StyledTableCell align="right" className={`${styles.table_head}`} > Closing Balance </StyledTableCell>
                                </StyledTableRow>
                            </TableHead>
                            <TableBody>
                                {reportPrint && reportPrint.map((row, index) => (
                                    <>
                                        <StyledTableRow
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.refNo}</StyledTableCell>
                                            <StyledTableCell align="left" className={`${styles.list_table_body}`} > {dateConversion(row.refDate)} </StyledTableCell>
                                            <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.payment_mode == null ? '-' : row.payment_mode}</StyledTableCell>
                                            <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.bankName == null ? '-' : row.bankName}</StyledTableCell>
                                            <StyledTableCell align="right" className={`${styles.list_table_body}`}>{parseFloat(row.openingBalance).toFixed(2)}</StyledTableCell>
                                            <StyledTableCell align="right" className={`${styles.list_table_body}`}>{parseFloat(row.creditAmt).toFixed(2)}</StyledTableCell>
                                            <StyledTableCell align="right" className={`${styles.list_table_body}`}>{parseFloat(row.debitAmt).toFixed(2)}</StyledTableCell>
                                            <StyledTableCell align="right" className={`${styles.list_table_body}`}>{parseFloat(row.closingBalance).toFixed(2)}</StyledTableCell>
                                        </StyledTableRow>
                                    </>
                                ))
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            </Box>
        </>
    )
}
export default AccountStatementPrint;

